import React, { useMemo } from 'react';
import format from 'date-fns/format';
import { toast } from 'components/Shared/Toast'
import { useTranslation } from 'react-i18next';

import { parseDate } from 'utils';
import { PropertyItem } from './Participant';

export function Attachments({ userForm = {} }) {
    const { t } = useTranslation();
    const participant = useMemo(() => userForm.template?.participants?.find(p => p._id === userForm?.participantId || p._id === userForm?.form?.participantId), [userForm])
    const attachmentsToHide = useMemo(() => Object.values(userForm.attachmentsToHide), [userForm.attachmentsToHide])
    console.log({participant})

    return (
        <div className="p-3 overflow-y-auto">
            <h4>{t('Anexos')}</h4>
            {
                participant?.attachments?.map(attachment => {
                    if (attachmentsToHide.includes(attachment._id)) return null;
                    const userAttachment = userForm.attachments?.[attachment._id];
                    return (
                        <PropertyItem label={attachment.name} value={userAttachment.name || 'No se ha subido un archivo'} url={userAttachment.url} required={attachment.required}  />
                    )
                })
            }
        </div>
    )
};

